import { IMonthsOfTheYear } from 'services/http/flow';
import { IResponseNisaParameters } from 'services/http/nisaParameters';

export const findEmptyCurrentMonthParameters = (
	data: IResponseNisaParameters[],
	currentMonth: string | number,
): string[] => {
	if (!data || !data.length) return [];

	const emptyParams: string[] = [];
	const currentMonthKey = `month${currentMonth}` as keyof IMonthsOfTheYear;

	data.forEach(item => {
		Object.entries(item).forEach(([paramName, paramValue]) => {
			if (typeof paramValue === 'object' && paramValue !== null) {
				const monthValue = paramValue[currentMonthKey];

				const stringValue = String(monthValue);

				if (
					monthValue === null ||
					monthValue === undefined ||
					stringValue === '' ||
					stringValue === '0.00' ||
					stringValue === '0' ||
					stringValue === '0.0'
				) {
					emptyParams.push(paramName);
				}
			}
		});
	});

	const uniqueEmptyParams = emptyParams.filter((param, index, array) => array.indexOf(param) === index);

	return uniqueEmptyParams;
};
